<script>
// import { useLaunchStore } from "../stores/LaunchStore";
// import { mapState } from "pinia";

import { mapState, mapGetters, mapActions } from "vuex";
import AnnouncementBanner from "./AnnouncementBanner.vue";
import AppIconBase from "./AppIconBase.vue";
import ResponsiveImage from "./AppResponsiveImage.vue";

export default {
  components: {
    AnnouncementBanner,
    ResponsiveImage,
    AppIconBase,
  },
  data() {
    return {
      isBtnHover: false,
      mediaQuery: null,
      isSmall: false,
      langsDeVideo: ["de-DE", "de-CH", "de-AT"],
      deLocales: ["fr-BE", "fr-FR", "nl-BE", "nl-NL", "pl-PL"],
      currLang: document.documentElement.lang,
      // videoPayload: {
      //   vimeoId: "744986717",
      // },
    };
  },
  mounted() {
    this.mediaQuery = window.matchMedia("(min-width: 991px)");
    this.mediaQuery.addEventListener("change", this.handleMediaQueryChange);
    this.handleMediaQueryChange(``);
  },
  computed: {
    //...mapState(useLaunchStore, ["heroContent"]),
    ...mapGetters(["heroContent"]),
    videoPayload() {
      const videoPayload = {
        vimeoId: null,
      };
      const rootLang = document.documentElement.lang;

      if (this.langsDeVideo.includes(rootLang)) {
        videoPayload.vimeoId = "758751685";
      } else if (rootLang === "nl-NL" || rootLang === "nl-BE") {
        videoPayload.vimeoId = "761456717";
      } else if (
        rootLang === "fr-FR" ||
        rootLang === "fr-BE" ||
        rootLang === "fr-CH"
      ) {
        videoPayload.vimeoId = "761456781";
      } else if (rootLang === "pl-PL") {
        videoPayload.vimeoId = "761456865";
      }
      else if (rootLang === "ja-JP") {
        videoPayload.vimeoId = "791274743";
      } else {
        videoPayload.vimeoId = "744986717";
      }

      return videoPayload;
    },
  },
  methods: {
    ...mapActions(["toggleModal"]),
    handleMediaQueryChange() {
      if (this.mediaQuery.matches) {
        this.isSmall = false;
      } else {
        this.isSmall = true;
      }
    },
    swapIcon() {
      this.playIcon = "PlayVideoIconHover";
    },
  },
};
</script>

<template>
  <div class="hero vw-dark-surface" id="hero">
    <picture v-if="langsDeVideo.includes(currLang)">
      <source media="(min-width:1200px)"
        srcset="https://res.cloudinary.com/vectorworks/image/upload/f_auto/q_90/pages/2023/illustrations/de/2208-launch-signature-images-design-suite-web-hero_de.png" />
      <source media="(min-width:750px)"
        srcset="https://res.cloudinary.com/vectorworks/image/upload/f_auto/q_90/pages/2023/illustrations/de/2208-launch-signature-images-design-suite-web-hero-mid_de.png" />
      <source
        srcset="https://res.cloudinary.com/vectorworks/image/upload/f_auto/q_90/pages/2023/illustrations/de/2208-launch-signature-images-design-suite-web-hero-mobile_de.png" />
      <img class="heroImg"
        src="https://res.cloudinary.com/vectorworks/image/upload/f_auto/q_90/pages/2023/illustrations/de/2208-launch-signature-images-design-suite-web-hero-mid_de.png" />
    </picture>
    <picture v-else>
      <source media="(min-width:1200px)"
        srcset="https://res.cloudinary.com/vectorworks/image/upload/f_auto/q_90/pages/2023/illustrations/2208-launch-signature-images-design-suite-web-hero.png" />
      <source media="(min-width:750px)"
        srcset="https://res.cloudinary.com/vectorworks/image/upload/f_auto/q_90/pages/2023/illustrations/2208-launch-signature-images-design-suite-web-hero-mid.png" />
      <source
        srcset="https://res.cloudinary.com/vectorworks/image/upload/f_auto/q_90/pages/2023/illustrations/2208-launch-signature-images-design-suite-web-hero-mobile.png" />
      <img class="heroImg"
        src="https://res.cloudinary.com/vectorworks/image/upload/f_auto/q_90/pages/2023/illustrations/2208-launch-signature-images-design-suite-web-hero-mid.png" />
    </picture>

    <div class="heroOverlay"></div>
    <AnnouncementBanner :content="heroContent.announcementBanner" />
    <div class="vw-grid heroContentWrapper">
      <div class="hero-content">
        <h1 class="heading-1">{{ heroContent.title }}</h1>
        <p class="leadText">{{ heroContent.tagline }}</p>
        <a class="heroCta" @click="toggleModal(videoPayload)" @mouseover="isBtnHover = true"
          @mouseleave="isBtnHover = false">
          <AppIconBase :name="isBtnHover ? `PlayVideoIconHover` : `PlayVideoIcon`" class="icon" />
          {{ heroContent.cta }}
        </a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../styles/01-settings/breakpoints";
@import "../styles/01-settings/mq";

.hero {
  --pillHeight: 45px;
  --size: 26px;
  height: 420px;
  position: relative;
  color: var(--text-color);
  align-items: left;
}

.heroOverlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--primary);
  opacity: 0.35;
  z-index: 0;
}

.heroContentWrapper {
  height: 100%;
  margin-top: 0;
  position: relative;
  z-index: 100;
}

.hero-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  grid-column: 1/-1;
  text-align: center;
}

h1,
p {
  text-align: center;
  font-family: Din;
}

.leadText {
  color: currentColor;
  margin-top: 10px;
  margin-top: 10px;
  font-family: Din, Arial, Helvetica, sans-serif;
  font-size: 18px;
  font-weight: 400;
  font-stretch: condensed;
}

.heroCta {
  margin-top: 40px;
  display: flex;
  width: 100%;
  font-size: 24px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-stretch: condensed;
}

.heroCta svg {
  fill: currentColor;
  margin-right: 12px;
}

@include mq($from: sm, $until: md) {
  .leadText {
    font-size: 20px;
  }
}

@include mq($from: lg) {
  .hero {
    height: 725px;
    margin-top: 45px;
  }

  .leadText {
    color: currentColor;
    margin-top: 20px;
    font-size: 36px;
    font-weight: 500;
    font-stretch: condensed;
  }

  .heroContentWrapper {
    margin-top: calc(-1 * var(--pillHeight));
  }
}

.heroImg {
  z-index: -1;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/HeroBanner.vue